import { buildImage } from '@/utils/action-lib'
export default (data: PAGE_CONFIG) => {
  const backgrounds = data.landing_backgrounds
  return `${backgrounds.map(buildImage).join('')}`
}
